import { render, staticRenderFns } from "./FaqsApplicants.vue?vue&type=template&id=6fb72f10&scoped=true&"
import script from "./FaqsApplicants.vue?vue&type=script&lang=js&"
export * from "./FaqsApplicants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb72f10",
  null
  
)

export default component.exports